export const pickPropertyFromMergedStyles = (
  mergedStyles: Record<string, string>[] | null | undefined,
  property: string,
): string | undefined => {
  if (typeof mergedStyles !== 'undefined' && mergedStyles !== null) {
    if (Array.isArray(mergedStyles)) {
      const propertyArray = mergedStyles.reduce((acc, style) => {
        return style[property] ? [style[property], ...acc] : acc;
      }, []);
      return propertyArray[0];
    } else {
      return mergedStyles[property];
    }
  }

  return undefined;
};
